import { apiClient } from '../../utils';
import { handleError } from '../';

export const toPost = async ({ si, pi, price, ...rest }) => {
  const payload = {
    ...rest,
    pci: pi,
    ...(si ? { si } : {}),
    ...(price ? { price } : {}),
  };

  try {
    const result = await apiClient.post(`/postChain/toPost`, {
      data: payload,
    });
    return result;
  } catch (e) {
    handleError(e);
    throw e;
  }
};
